(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/main-page.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/main-page.js');

'use strict';

const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;

const MainPage = _ref => {
  let {
    children
  } = _ref;
  return React.createElement("div", {
    className: "align-center f-body line-height-150 f-inverted padding-1"
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    xs: 12
  }, children))));
};
svs.playerLogin.sharedComponents.MainPage = MainPage;

 })(window);